import { TextProps } from '@bechtel/gds';
import { FC } from 'react';
import { TextContainerStyled } from './styled';
import { EllipsisPlacement, OverflowEllipsisProps } from './types';

type TextWithEllipsisProps = TextProps & OverflowEllipsisProps;
export const TextWithEllipsis: FC<TextWithEllipsisProps> = ({
  ellipsisPlacement = EllipsisPlacement.BEGINNING,
  ...props
}) => {
  return (
    <TextContainerStyled
      {...props}
    ></TextContainerStyled>
  );
};
